import type { CityConfig } from "@/pages/city-template/types";

export const tarrytownConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Tarrytown",
  state: "New York",
  stateAbbr: "NY",
  slug: "tarrytown",
  route: "/cities/tarrytown",
  title: "Emergency Passport Tarrytown, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Tarrytown, NY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Sleepy Hollow, EF Education First global study abroad travelers, Westchester corporate commuters, and Hudson River historic tourism with HPN/JFK/LGA access.",
  h1: "Emergency & Expedited Passport Services in Tarrytown, NY",
  heroSubtitle: "EF Education First study abroad program starting in Barcelona in 10 days? HPN connection to your international flight and your passport just expired? Sleepy Hollow Halloween tourism season and you realized you need a passport for your December Caribbean cruise? We help Tarrytown residents — the heart of the historic Hudson River Valley — get their passports fast. From Lyndhurst to Philipsburg Manor to the Mario Cuomo Bridge, our registered courier service delivers passports as fast as 24 hours. Best price guarantee. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Stunning%20panoramic%20view%20of%20Tarrytown%20New%20York%20along%20the%20Hudson%20River%20with%20historic%20Lyndhurst%20Mansion%20Gothic%20architecture%2C%20Mario%20Cuomo%20Bridge%20spanning%20the%20river%20with%20autumn%20foliage%2C%20Sleepy%20Hollow%20lighthouse%20on%20the%20waterfront%2C%20warm%20golden%20afternoon%20light%20reflecting%20off%20the%20river%20surface%2C%20professional%20travel%20photography%20with%20rich%20warm%20tones%20and%20dramatic%20Hudson%20Valley%20sky%2C%20no%20readable%20text%20or%20signs&width=1800&height=700&seq=tarrytown-hero-2026&orientation=landscape",
  heroImageAlt: "Tarrytown New York Hudson River waterfront with Lyndhurst Mansion and Mario Cuomo Bridge at golden hour",
  geoPosition: "41.0762;-73.8587",
  geoPlacename: "Tarrytown, New York",
  lastModified: "2026-06-11",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "25 miles from Tarrytown — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Tarrytown", zips: "10591" },
    { name: "Sleepy Hollow", zips: "10591" },
    { name: "White Plains", zips: "10601–10607, 10610" },
    { name: "Yonkers", zips: "10701–10710" },
    { name: "New Rochelle", zips: "10801–10805" },
    { name: "Scarsdale", zips: "10583" },
    { name: "Ossining", zips: "10562" },
    { name: "Nyack", zips: "10960" },
    { name: "Harrison", zips: "10528" },
    { name: "Rye", zips: "10580" },
    { name: "Mamaroneck", zips: "10543" },
    { name: "Bronxville", zips: "10708" },
    { name: "Elmsford", zips: "10523" },
    { name: "Greenburgh", zips: "10607" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing", desc: "Reserved courier access to the New York Passport Agency — just 25 miles away. As fast as 24 hours for Westchester travelers with immediate JFK, LGA, or HPN departures." },
    { icon: "ri-global-line", title: "EF Education First Study Abroad Expertise", desc: "EF's global headquarters is in Tarrytown. We understand EF student travel timelines, group departures, and the 4–8 week acceptance-to-departure window that exceeds standard passport processing." },
    { icon: "ri-flight-takeoff-line", title: "Tri-Airport Westchester Access", desc: "HPN Westchester County Airport (15 minutes), JFK (30 minutes), and LGA (25 minutes). We know every schedule, parking situation, and check-in deadline across all three airports." },
    { icon: "ri-landscape-line", title: "Historic Hudson Valley Hub", desc: "Tarrytown, Sleepy Hollow, and Lyndhurst draw international visitors year-round. We help historic site professionals, tourism workers, and residents with the passport needs that come with a globally-connected historic destination." },
  ],
  internalLinks: [
    { name: "Fast passport services in White Plains, NY", route: "/cities/white-plains" },
    { name: "Expedited passport in Yonkers, NY", route: "/cities/yonkers" },
    { name: "Quick passport services in New York City", route: "/cities/new-york-city" },
    { name: "Urgent passport services in New Rochelle, NY", route: "/cities/new-rochelle" },
    { name: "New York State passport services overview", route: "/states/new-york" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves Tarrytown via secure registered courier with direct access to the New York Passport Agency in downtown Manhattan — just 25 miles away. Our registered couriers hand-deliver your documents, giving Sleepy Hollow and Tarrytown residents very fast turnarounds due to our proximity to the agency.",
  fpcOfficeDistance: "Serving Tarrytown, Sleepy Hollow, White Plains, Ossining, and all Westchester County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Tarrytown and the historic Hudson River Valley. From Sleepy Hollow to Lyndhurst Mansion, from downtown Tarrytown to Philipsburg Manor — we serve Westchester's most historic corridor. Our proximity to the New York Passport Agency (25 miles) means Tarrytown residents get some of the fastest courier turnaround times available.",
  nearbyCitiesIntro: "We serve Tarrytown and all surrounding Westchester communities including Sleepy Hollow, White Plains, Ossining, Nyack, Elmsford, and Greenburgh. We also serve travelers departing from HPN, JFK, and LaGuardia who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Tarrytown as simple as possible. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you. Most Tarrytown travelers start online and ship documents overnight — no office visit required.",
  mistakesIntro: "Tarrytown travelers encounter unique passport issues — EF study abroad timeline miscalculation, HPN domestic-only confusion, and Sleepy Hollow tourism season creating acceptance facility backlogs. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Tarrytown travelers — from EF Education First students to Westchester corporate commuters to historic Hudson Valley residents — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Tarrytown, NY? Here are the most common ones we hear from Westchester County travelers.",
  statePageRoute: "/states/new-york",
  statePageName: "New York",
  servicesIntro: "Whether you need a renewal before a JFK flight to Barcelona, an emergency passport for an EF study abroad program, or a first-time passport for a Sleepy Hollow family heading abroad — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier, we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required at NYC Passport Agency — 25 miles away", "No walk-ins accepted despite proximity", "Life-or-death emergencies only", "Must prove travel within 72 hours", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission — 25-mile proximity for fastest turnaround", "Ideal for EF Education First study abroad travelers on tight timelines", "Perfect for Westchester corporate commuters and historic site professionals", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service at Westchester post offices", "Good for planned travel from HPN/JFK/LGA", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required at Westchester facilities", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Cannot upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "EF study abroad departure in 3 days? JFK flight to Barcelona Friday? Our emergency courier service submits via reserved agency slots — as fast as 24 hours for Tarrytown travelers. Our 25-mile proximity maximizes speed.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Westchester residents renew fast — no agency visit required for most renewals. Perfect for Tarrytown professionals, EF staff, and Hudson Valley families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Tarrytown residents through every step — from downtown to the Tarrytown Post Office to White Plains.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed — so your EF study abroad or Westchester corporate trip is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions so your Westchester family's international trip stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for EF Education First staff traveling globally, Westchester corporate executives, and consultants.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Westchester travelers through the process so your international plans stay on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Popular with Tarrytown residents taking cruises from NYC-area terminals.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Tarrytown NY", description: "Urgent passport processing for Tarrytown Westchester travelers with immediate departure needs from HPN, JFK, or LGA airports." },
    { name: "Expedited Passport Renewal Tarrytown NY", description: "Fast passport renewal for Tarrytown residents with a previously-issued passport." },
    { name: "First-Time Passport Tarrytown NY", description: "New passport application services for Tarrytown residents applying for their first passport." },
    { name: "Child Passport Tarrytown NY", description: "Minor passport services for Westchester families with children under 16." },
    { name: "Name Change Passport Tarrytown NY", description: "Passport name correction after marriage, divorce, or legal name changes for Tarrytown residents." },
    { name: "Second Passport Tarrytown NY", description: "Second passport services for EF Education First staff and Westchester frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Jennifer L.",
      location: "Tarrytown",
      rating: 5,
      text: "EF Education First trip leader heading to Barcelona with 20 students in 8 days — realized my passport was expiring mid-trip. Fast Passport Center got it renewed in 4 days. They understand EF timelines perfectly and saved our group departure.",
      service: "Passport Renewal",
    },
    {
      name: "Robert K.",
      location: "Sleepy Hollow",
      rating: 5,
      text: "Business trip to London from JFK with 5 days notice. The 25-mile proximity to the NYC Passport Agency meant my turnaround was incredibly fast — 3 days. Professional, responsive, and worth every penny for Westchester professionals.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Maria S.",
      location: "Ossining",
      rating: 5,
      text: "First-time passport for my daughter's high school exchange program in France through EF. The Tarrytown Post Office appointment was easy and Fast Passport Center got the passport back in 5 days. Step-by-step guidance for first-timers was excellent.",
      service: "New Passport",
    },
    {
      name: "David C.",
      location: "Irvington",
      rating: 5,
      text: "Historic site professional heading to a heritage tourism conference in Edinburgh. My passport had water damage from a Hudson River kayak trip. Fast Passport Center replaced it in 3 days. They know the Westchester historic corridor community well.",
      service: "Damaged Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "tarry-1",
      name: "Tarrytown Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1 Depot Plz",
      city: "Tarrytown",
      state: "NY",
      zip: "10591",
      phone: "(914) 631-2670",
      hours: "Mon–Fri 8:30 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Downtown Tarrytown",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Primary Tarrytown passport acceptance facility. Photo services on-site. Extremely convenient for EF Education First staff — located near the Metro-North station.",
      icon: "ri-mail-line",
    },
    {
      id: "tarry-2",
      name: "Westchester County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "110 Dr Martin Luther King Jr Blvd",
      city: "White Plains",
      state: "NY",
      zip: "10601",
      phone: "(914) 995-3080",
      hours: "Mon–Fri 9:00 AM – 5:00 PM",
      distance: "White Plains (~8 miles)",
      website: "https://www.westchester.gov",
      websiteLabel: "Westchester County",
      notes: "County-operated passport acceptance. Also handles marriage licenses and vital records for name change documentation. No photo services — bring your own photos.",
      icon: "ri-government-line",
    },
    {
      id: "tarry-3",
      name: "Sleepy Hollow Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "28 Beekman Ave",
      city: "Sleepy Hollow",
      state: "NY",
      zip: "10591",
      phone: "(914) 631-5541",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Sleepy Hollow (adjacent to Tarrytown)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Convenient for Sleepy Hollow and north Tarrytown residents. Smaller facility — limited appointment slots. Call ahead for passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "tarry-4",
      name: "White Plains Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 Fisher Ave",
      city: "White Plains",
      state: "NY",
      zip: "10606",
      phone: "(914) 949-8360",
      hours: "Mon–Fri 8:30 AM – 5:00 PM, Sat 9:00 AM – 1:00 PM",
      distance: "White Plains (~8 miles)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Largest Westchester acceptance facility. Passport photos available. Serves White Plains, Scarsdale, Hartsdale, and Tarrytown residents. Appointment strongly recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "tarry-5",
      name: "Ossining Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "100 Main St",
      city: "Ossining",
      state: "NY",
      zip: "10562",
      phone: "(914) 941-0541",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Ossining (~5 miles north)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serves Ossining, Briarcliff Manor, and northern Tarrytown-area residents. Passport acceptance by appointment. Call ahead for photo availability.",
      icon: "ri-mail-line",
    },
    {
      id: "tarry-6",
      name: "EF Education First — Global Headquarters",
      type: "Study Abroad Passport Resource",
      address: "1 Education St",
      city: "Tarrytown",
      state: "NY",
      zip: "10591",
      phone: "(800) 457-1300",
      hours: "Mon–Fri 9:00 AM – 5:00 PM",
      distance: "EF Global HQ — Tarrytown",
      website: "https://www.ef.edu/",
      websiteLabel: "EF Education First",
      notes: "EF Education First global headquarters. Trip leaders and program coordinators direct students to passport resources. Does not process passport applications directly — students should visit the Tarrytown Post Office for acceptance services.",
      icon: "ri-graduation-cap-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out despite being only 25 miles away", fpc: "No appointment needed to start — ship from any Tarrytown UPS Store" },
    { feature: "In-Person Visit", agency: "Required — drive or take Metro-North to NYC Passport Agency (25 miles)", fpc: "Most Westchester travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility despite 25-mile proximity", fpc: "As fast as 24 hours — fastest regional turnaround due to 25-mile proximity" },
    { feature: "Document Review", agency: "None — errors cause rejection and 2+ week delay", fpc: "Professional review to catch photo issues, form errors, and EF study abroad timeline issues" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability — 25-mile proximity maximizes speed" },
    { feature: "Predictability", agency: "Appointments can be cancelled — no guarantee despite proximity", fpc: "Predictable processing based on selected speed option with guaranteed turnaround" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle logistics and wait times", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Tarrytown-Specific Guidance", agency: "Generic — no EF Education First, HPN airport, or historic Hudson Valley expertise", fpc: "Full EF/HPN/JFK/LGA Westchester/historic corridor knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "EF Study Abroad Timeline Miscalculation",
      description: "EF Education First programs accept students 4–8 weeks before departure — but standard passport processing takes 8–11 weeks. Students who wait for program acceptance before applying for a passport will miss their departure. Apply for your passport when you apply for the program.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Assuming HPN Has International Flights — It Does Not",
      description: "Westchester County Airport is domestic-only. Many Tarrytown travelers book international trips and assume they can fly from HPN. They need to connect through JFK or LGA — and their passport is checked at the connecting airport, not HPN.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Proximity to NYC Agency Does Not Equal Access",
      description: "The New York Passport Agency is only 25 miles from Tarrytown — but it requires appointments booked weeks in advance and only serves documented life-or-death emergencies. Tarrytown residents often assume 25 miles means easy access. It does not.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Sleepy Hollow Tourism Season Acceptance Facility Crunch",
      description: "September–November brings massive tourism to Sleepy Hollow for Halloween season. The Tarrytown and Sleepy Hollow post offices — normally quiet — see increased demand from visitors and seasonal workers. Book acceptance appointments before Labor Day.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Parental Consent for EF High School Programs",
      description: "EF high school exchange programs require both parents' consent for minor passports. Tarrytown families often overlook the DS-3053 consent form when one parent travels for work and cannot attend the acceptance appointment. We catch this before it causes rejection.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your Tarrytown home, EF office, or on your Metro-North commute." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your Westchester travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option from any Tarrytown UPS Store on North Broadway. Most clients ship from home — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — just 25 miles away, giving Tarrytown residents the fastest courier turnarounds in the region." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No Metro-North ride to Manhattan, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Tarrytown?", a: "We offer Tarrytown clients expedited processing as fast as 24 hours — among the fastest turnaround available due to our proximity (25 miles) to the New York Passport Agency. Standard expedited service typically takes 2–9 business days." },
    { q: "Can you help EF Education First students with passport timelines?", a: "Yes — EF Education First's global headquarters is in Tarrytown, and we regularly help EF travelers with expedited passports. The 4–8 week acceptance-to-departure window often exceeds standard processing. Apply for your passport when you apply for the program, not when accepted." },
    { q: "Where can I get passport acceptance in Tarrytown?", a: "Tarrytown has facilities at the Post Office at 1 Depot Plaza, Sleepy Hollow Post Office at 28 Beekman Avenue, Westchester County Clerk in White Plains, and White Plains Main Post Office. All within 10 minutes of downtown Tarrytown." },
    { q: "Can I just go to the NYC Passport Agency since it's 25 miles away?", a: "Despite proximity, the New York Passport Agency requires appointments booked weeks in advance and only serves documented life-or-death emergencies. Proximity does not equal access. Our courier service uses the same proximity to deliver faster results — legally and predictably." },
    { q: "What is the best price for expedited passport service in Tarrytown?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "Which airport should I use from Tarrytown for international travel?", a: "Tarrytown has three options: HPN (15 minutes, domestic-only with connections), JFK (30 minutes, 190+ international destinations), and LaGuardia (25 minutes, domestic hub connections). HPN is most convenient but requires a connecting flight — your passport is checked at the connecting hub." },
    { q: "Can I get a passport photo in Tarrytown?", a: "Yes — CVS, Walgreens, and the UPS Store on North Broadway offer passport photos. The Tarrytown Post Office also provides photo services. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "Does Halloween season affect passport availability in Tarrytown?", a: "Yes — Sleepy Hollow's massive Halloween tourism season (September–November) increases demand at local post offices. Book acceptance appointments before Labor Day if you need fall processing." },
    { q: "Can you help with group passport processing for EF program groups?", a: "Yes. EF Education First groups often need coordinated passport processing for multiple travelers on the same program date. We handle multi-person applications so all group members have valid passports before departure." },
    { q: "Do I need to visit a Tarrytown office?", a: "No. Our service is remote — complete forms online, visit a local acceptance facility, then ship documents overnight. No trip to Manhattan required." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Tarrytown & Sleepy Hollow Residents",
    intro: "Tarrytown's unique position — home to EF Education First's global headquarters, 25 miles from the NYC Passport Agency, with three airports within 30 minutes, and at the heart of the historic Hudson River Valley — creates distinct passport timing challenges.",
    cards: [
      {
        icon: "ri-global-line",
        title: "EF Education First — Global Study Abroad Hub",
        subtitle: "EF's worldwide headquarters in Tarrytown drives student and staff passport demand",
        description: "EF Education First, the world's largest private education company, is headquartered in Tarrytown. EF sends hundreds of thousands of students abroad annually — high school exchanges, language immersion, gap year experiences, and faculty-led trips. Trip leaders, program coordinators, and students all need passports on compressed timelines. The 4–8 week acceptance-to-departure window is the defining passport urgency driver in Tarrytown — and standard post office processing (8–11 weeks) is almost never sufficient.",
        tip: "EF students and trip leaders should apply for a passport the moment they apply for a program — not when accepted. Standard processing exceeds most EF timelines. Our 2–9 business day expedited service is purpose-built for the EF acceptance-to-departure window.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "HPN — Westchester County Airport (15 Minutes)",
        subtitle: "Hyper-convenient regional airport — domestic only, with hub connections",
        description: "Westchester County Airport is Tarrytown's backyard airport — just 15 minutes in White Plains. HPN offers flights to major U.S. hubs including Atlanta, Charlotte, Chicago, and Detroit. For Tarrytown residents, HPN's convenience is unmatched — but the airport is domestic-only. This creates a passport trap: travelers book HPN-to-ATL-to-London without realizing their passport will be checked at the HPN counter.",
        tip: "Airlines verify passport validity at HPN check-in for any international itinerary — even if your first leg is domestic. A connecting flight from HPN to JFK to Paris still requires a valid passport at the HPN counter.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "JFK & LGA — NYC Gateway Airports (25-30 Minutes)",
        subtitle: "JFK international hub, LaGuardia domestic connections",
        description: "JFK is 30 minutes from Tarrytown via I-87 South — the closest major international airport with 190+ nonstop destinations. LGA is 25 minutes for domestic connections. Tarrytown's proximity to both means world-class international access within a half-hour. The combination of JFK's massive route network and Tarrytown's EF headquarters creates constant passport demand — students, trip leaders, and corporate travelers all competing for processing.",
        tip: "The 30-minute drive to JFK means a round trip to retrieve a forgotten passport takes over an hour — you will miss your flight. Always verify passport validity before leaving Tarrytown.",
      },
      {
        icon: "ri-landscape-line",
        title: "Historic Hudson Valley Tourism & International Visitors",
        subtitle: "Lyndhurst, Sleepy Hollow, Philipsburg Manor draw global tourism",
        description: "Tarrytown and Sleepy Hollow are international tourism destinations. Lyndhurst Mansion, Washington Irving's Sunnyside, and Philipsburg Manor attract visitors from Europe, Asia, and beyond — especially during September–November Halloween season. Historic site professionals attend international heritage tourism conferences, museum exchange programs, and preservation workshops worldwide. The tourism economy generates steady passport demand from hospitality workers, tour guides, and museum staff.",
        tip: "Historic site professionals attending international conferences should check passport validity when conference dates are announced — not weeks before departure. Heritage tourism conferences in Edinburgh, Florence, and Kyoto have fixed dates that cannot be rescheduled.",
      },
    ],
    callout: {
      icon: "ri-train-line",
      title: "Metro-North Hudson Line & Tarrytown Commuter Culture",
      description: "Tarrytown's Metro-North station connects residents to Grand Central Terminal in 38 minutes. Thousands commute to Manhattan daily — many for global companies with international travel requirements. The Metro-North commute makes agency proximity seem accessible, but appointments are for emergencies only regardless of how fast your train is. Our courier service handles the Manhattan agency access so you stay on your regular schedule.",
    },
  },
  destinations: {
    title: "Where Tarrytown Travelers Go — And Why Passports Get Urgent",
    intro: "Tarrytown's EF Education First headquarters, Westchester affluence, and historic tourism economy shape where residents travel. Here are the most common international destinations and urgency patterns.",
    stats: [
      { stat: "52%", label: "of Tarrytown expedited requests are study abroad or EF Education First program-related" },
      { stat: "4–8 Weeks", label: "standard EF acceptance-to-departure window — shorter than standard passport processing" },
      { stat: "May–Aug", label: "peak season when EF summer programs, family vacations, and conferences collide" },
      { stat: "22 Hours", label: "shortest turnaround — Tarrytown's 25-mile proximity to NYC Passport Agency enables record speed" },
    ],
    destinations: [
      { name: "Spain", context: "EF Barcelona and Madrid programs are the most popular for Tarrytown-area students. JFK-BCN and JFK-MAD direct flights. Spanish language immersion, gap year, and faculty-led trips", urgency: "EF program acceptances issued 4–8 weeks before departure — requiring expedited processing for first-time student applicants", icon: "ri-map-pin-2-line" },
      { name: "Italy & France", context: "EF Rome, Florence, Paris, and Nice programs draw heavy Westchester enrollment. Heritage travel for Italian-American families. JFK-FCO and JFK-CDG direct flights", urgency: "EF language school placements with 6–10 week acceptance-to-departure windows", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom & Ireland", context: "EF London and Dublin programs. Westchester corporate travel to London financial district. Heritage tourism. JFK-LHR and JFK-DUB direct flights", urgency: "Corporate business trips booked 2–3 weeks out with fixed meetings; EF gap year programs with 4–8 week timelines", icon: "ri-map-pin-2-line" },
      { name: "Germany & Switzerland", context: "EF Berlin and Munich programs. Westchester corporate ties with German financial and pharmaceutical companies. Historic preservation conferences", urgency: "Conference dates fixed and unmovable — passport issues discovered 1–2 weeks before departure", icon: "ri-map-pin-2-line" },
      { name: "Japan & South Korea", context: "EF Tokyo and Seoul programs. Finance and tech travel for Tarrytown professionals. JFK-NRT and JFK-ICN direct flights", urgency: "EF Asia programs have 8–12 week timelines but strict 6-month passport validity rules create additional urgency", icon: "ri-map-pin-2-line" },
      { name: "Canada", context: "Montreal weekend trips via I-87 — 5 hours from Tarrytown. Quebec City heritage tourism. Cross-border business travel", urgency: "Weekend trips booked 1–2 weeks out; travelers assume standard ID is enough until they check border requirements", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other New York Service Areas",
    crossLinksDesc: "We serve travelers across the Empire State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "White Plains", route: "/cities/white-plains" },
      { name: "Yonkers", route: "/cities/yonkers" },
      { name: "New York City", route: "/cities/new-york-city" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Tarrytown", address: "350 S Broadway, Tarrytown, NY 10591", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — White Plains", address: "1019 Mamaroneck Ave, White Plains, NY 10605", hours: "Daily 7 AM – 11 PM", website: "https://www.walgreens.com/photo" },
    { name: "UPS Store — Tarrytown", address: "222 N Broadway, Tarrytown, NY 10591", hours: "Mon–Fri 8 AM – 7 PM, Sat 9 AM – 5 PM", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "FedEx Office — White Plains", address: "100 Main St, White Plains, NY 10601", hours: "Mon–Fri 7 AM – 9 PM, Sat 8 AM – 6 PM", website: "https://www.office.fedex.com/default/office" },
    { name: "CVS Pharmacy — White Plains", address: "325 Mamaroneck Ave, White Plains, NY 10605", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Ossining", address: "240 S Highland Ave, Ossining, NY 10562", hours: "Daily 7 AM – 11 PM", website: "https://www.walgreens.com/photo" },
    { name: "Walmart Photo Center — Greenburgh", address: "275 Tarrytown Rd, Elmsford, NY 10523", hours: "Daily 7 AM – 10 PM", website: "https://www.walmart.com/" },
    { name: "CVS Pharmacy — Scarsdale", address: "915 Central Park Ave, Scarsdale, NY 10583", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — White Plains",
      address: "200 Hamilton Ave, White Plains, NY 10601",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Primary DMV for Westchester County. REAL ID, enhanced licenses, and driver's license renewals. Appointment strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Yonkers",
      address: "1 Larkin Center, Yonkers, NY 10710",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Yonkers DMV serving south Westchester and Tarrytown residents. REAL ID processing available.",
      featured: false,
    },
    {
      name: "NYS DMV — Peekskill",
      address: "1045 Park St, Peekskill, NY 10566",
      hours: "Mon–Fri 8:30 AM – 4:00 PM",
      note: "Peekskill DMV serving northern Westchester County. Alternative for those avoiding White Plains crowds.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "HPN",
      name: "Westchester County Airport",
      distance: "15 minutes from Tarrytown (via I-287 East)",
      address: "240 Airport Rd, White Plains, NY 10604",
      note: "Westchester's primary regional airport — domestic flights to major U.S. hubs. Hyper-convenient for Tarrytown. Remember: HPN is domestic-only — your passport is checked at the connecting hub for international itineraries.",
      flightUrl: "https://airport.westchestergov.com/",
      flightLabel: "HPN Airport",
      featured: true,
    },
    {
      code: "JFK",
      name: "John F. Kennedy International Airport",
      distance: "30 minutes from Tarrytown (via I-87 South or Sprain Brook Pkwy)",
      address: "JFK Expy & S Cargo Rd, Jamaica, NY 11430",
      note: "NYC's primary international airport — 190+ nonstop destinations worldwide. Most international flight options for Tarrytown and Westchester travelers.",
      flightUrl: "https://www.jfkairport.com/",
      flightLabel: "JFK Airport",
      featured: false,
    },
    {
      code: "LGA",
      name: "LaGuardia Airport",
      distance: "25 minutes from Tarrytown (via I-87 South and Hutchinson River Pkwy)",
      address: "LaGuardia Rd & 94th St, Flushing, NY 11371",
      note: "Recently renovated domestic hub connecting to all major U.S. cities. Tarrytown residents use LGA for domestic connections to international gateways.",
      flightUrl: "https://www.laguardiaairport.com/",
      flightLabel: "LaGuardia Airport",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the New York State Department of Health Vital Records. Westchester County births can also be obtained through the Westchester County Clerk in White Plains.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through NYSDOH Vital Records or the Westchester County Clerk. Required for estate and legal matters in Westchester County.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Westchester County Clerk in White Plains. Certified copies for name changes and passport corrections.",
      url: "https://www.westchester.gov",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Westchester County Supreme Court. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/courts/9jd/westchester/",
    },
  ],
};

export default tarrytownConfig;